import type { QuizManifestEntry, QuizOptionSpec } from "@-/dev.improve.haniverse.assets.slides";
import { createContext } from "react";

/** One showing of a quiz card: its options in this showing's order, and the learner's answer. */
export type QuizCardContextValue = {
  /** Set once the learner checks their selection; the options then show the answer key. */
  answer: { correct: boolean } | null;
  /** Whether this showing takes input (the current card, at rest). */
  isInteractive: boolean;
  options: readonly QuizOptionSpec[];
  quiz: QuizManifestEntry;
  selected: ReadonlySet<string>;
  toggle: (glyph: string) => void;
};

export const QuizCardContext = createContext<QuizCardContextValue | null>(null);
